import { Copy, Check, Mail, Phone } from 'lucide-react';
import { useState } from 'react';

export default function PhoneButton({ isOpen, onToggle }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText('jonassnk11@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={onToggle}
        className={`fixed bottom-4 right-1 sm:w-16 sm:h-16 w-16 h-16 bg-gradient-to-tr from-cyan-500 to-blue-500 text-white rounded-full shadow-lg flex items-center justify-center z-50 transition-transform duration-300 hover:scale-110 `}
        aria-label="Kontakt"
      >
        {/* Animate Phone/X Icon */}
        <div className="relative w-6 h-6">
          <Phone
            className={`absolute inset-0 w-full h-full transition-all duration-500 ${
              isOpen ? 'opacity-0 scale-50 rotate-[360deg]' : 'opacity-100 scale-100 animate-pulse'
            }`}
          />
          <Check
            className={`absolute inset-0 w-full h-full transition-all duration-500 ${
              isOpen ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-50 -rotate-[360deg]'
            }`}
          />
        </div>
      </button>

      {/* Popup Box */}
      <div
        className={`fixed bottom-20 right-16 w-64 z-40 transition-all duration-500 ease-out ${
          isOpen ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-4 opacity-0 scale-95 pointer-events-none'
        }`}
      >
        <div className="bg-white rounded-xl shadow-2xl border border-blue-200 overflow-hidden transform transition-all duration-500">
          {/* Header */}
          <div
            className={`bg-gradient-to-r from-cyan-500 to-blue-500 text-white p-4 text-center relative transition-all duration-500 rounded-t-xl ${
              isOpen ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'
            }`}
          >
            
            <div className="text-lg font-bold">Jonas Schütt Nielsen</div>
            <div className="text-sm opacity-90 mt-1">Ring eller skriv til mig</div>

            <button
              onClick={onToggle}
              className="absolute top-2 right-2 text-white hover:text-gray-200 transition-all duration-300 p-1 hover:rotate-90 hover:scale-110"
              aria-label="Luk"
            >
              <Check className="w-4 h-4" />
            </button>
          </div>

          {/* Contact Content */}
          <div
            className={`p-4 space-y-3 transition-all duration-500 ${
              isOpen ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
            }`}
          >
            {/* Phone Links */}
            <a
              href="tel:+38971374360"
              className="flex items-center gap-2 p-2 rounded-lg hover:bg-blue-50 transition-all duration-300 group"
            >
              <Phone size={18} className="text-blue-600 group-hover:text-blue-800 transition-colors duration-300" />
              <span className="text-blue-800 font-medium">MK: +389 071 374 360</span>
            </a>

            {/* Email Copy */}
            <button
              onClick={copyToClipboard}
              className="w-full flex items-center gap-2 p-2 rounded-lg border border-blue-200 hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group"
            >
              <Mail size={18} className="text-blue-600 group-hover:text-blue-800 transition-colors duration-300" />
              <span className="text-blue-800 text-sm truncate">jonassnk11@gmail.com</span>
              {copied ? (
                <Check size={18} className="text-green-500 ml-auto" />
              ) : (
                <Copy size={18} className="text-blue-600 ml-auto group-hover:text-blue-800 transition-colors duration-300" />
              )}
            </button>

            {/* Email Options */}
            <div className="space-y-2">
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=jonassnk11@gmail.com&su=${encodeURIComponent(
                  'Kontakt via hjemmeside'
                )}&body=${encodeURIComponent('Hej Jonas,\n\nJeg skriver angående...')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 p-2 rounded-lg border border-red-200 hover:border-red-400 hover:bg-red-50 transition-all duration-300 group"
              >
                <Mail size={18} className="text-red-500 group-hover:text-red-600 transition-colors duration-300" />
                <span className="text-red-600 group-hover:text-red-800 text-sm">Åbn i Gmail</span>
              </a>

              <a
                href={`https://outlook.live.com/mail/deeplink/compose?to=jonassnk11@gmail.com&subject=${encodeURIComponent(
                  'Kontakt via hjemmeside'
                )}&body=${encodeURIComponent('Hej Jonas,\n\nJeg skriver angående...')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 p-2 rounded-lg border border-blue-200 hover:border-blue-400 hover:bg-blue-50 transition-all duration-300 group"
              >
                <Mail size={18} className="text-blue-500 group-hover:text-blue-600 transition-colors duration-300" />
                <span className="text-blue-600 group-hover:text-blue-800 text-sm">Åbn i Outlook</span>
              </a>
            </div>
          </div>

          {/* Bottom Gradient Line */}
          <div
            className={`h-1 bg-gradient-to-r from-cyan-500 to-blue-500 transition-all duration-700 ${
              isOpen ? 'w-full' : 'w-0'
            }`}
          />
        </div>
      </div>
    </>
  );
}